import { useState, useEffect, useCallback } from 'react';
import { fetchDocuments } from '../services/documentService';
import { useProfile } from '../../../hooks/useProfile';

/**
 * Custom hook for managing employee documents
 * @param {Object} employeeData - Employee data object
 * @returns {Object} Documents state and methods
 */
export const useDocuments = (employeeData) => {
  const { profile } = useProfile();
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const infinityCode =
        profile?.infinityCode || employeeData?.infinityCode || localStorage.getItem('infinityCode');

      if (!infinityCode) {
        console.warn('No infinityCode found');
        setIsLoading(false);
        return;
      }

      const docs = await fetchDocuments(infinityCode);
      setDocuments(docs || []);
    } catch (err) {
      console.error('Failed to fetch documents:', err);
      setError(err.message || 'Failed to load documents');
    } finally {
      setIsLoading(false);
    }
  }, [employeeData?.infinityCode, profile?.infinityCode]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    documents,
    setDocuments,
    isLoading,
    error,
    refetch,
  };
};
